var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1038 6.31201H13.0372L9.43717 2.71201V5.64534C9.43717 6.04534 9.70384 6.31201 10.1038 6.31201ZM10.1038 7.64534C8.97051 7.64534 8.10384 6.77868 8.10384 5.64534V2.31201H4.77051C3.63717 2.31201 2.77051 3.17868 2.77051 4.31201V13.6453C2.77051 14.7787 3.63717 15.6453 4.77051 15.6453H11.4372C12.5705 15.6453 13.4372 14.7787 13.4372 13.6453V7.64534H10.1038Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.9bccd5b7f1c32e7b253f482eac68aa92.svg";
export { ForwardRef as ReactComponent };